import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';

import BetrLogo from '@/assets/icons/betr-small';
import { RadioItem } from '@/components/RadioItem';
import { Text } from '@/components/TextComponent';
import { Box, Row } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import BetrAnalytics from '@/feature/analytics/analytics';
import { AnalyticsEvent } from '@/feature/analytics/constants';
import { common } from '@/styles/styles';

import { SOCIAL_WALLET_PAYMENT_METHOD } from '../const';
import { PaymentMethod, PreferredPayment } from '../hooks/use-deposit-payment-methods';
import { paymentMethodStyles } from '../styles';

type AddPaymentMethodSocialWalletProps = {
    handleSelect: (method: PaymentMethod, preferredMethod?: PreferredPayment) => void;
    isSelected?: boolean;
};

export const AddPaymentMethodSocialWallet = ({
    handleSelect,
    isSelected = false,
}: AddPaymentMethodSocialWalletProps) => {
    const { t } = useTranslation('wallet');

    return (
        <Pressable
            style={[
                paymentMethodStyles.listItem,
                paymentMethodStyles.lineItemBorder,
                common.row,
                common.alignCenter,
                common.justifySpaceBetween,
            ]}
            onPress={() => {
                BetrAnalytics.trackProductEvent(AnalyticsEvent.DEPOSIT_METHOD_SOCIAL_WALLET);
                handleSelect(SOCIAL_WALLET_PAYMENT_METHOD);
            }}
        >
            <Row flex={1} alignItems={'center'}>
                <Box
                    width={48}
                    height={36}
                    marginRight="s16"
                    borderWidth={1}
                    borderColor={ds.colorToken.border.strong}
                    borderRadius="r8"
                    alignItems="center"
                    justifyContent="center"
                >
                    <BetrLogo size={24} />
                </Box>
                <Box flex={1}>
                    <Text variant="bodyLarge" color={ds.colorToken.text.primary}>
                        {t('social_wallet_funding')}
                    </Text>
                    <Box>
                        <Text variant="bodyMedium" color="neutral300" numberOfLines={1}>
                            {t('social_wallet_funding_description')}
                        </Text>
                    </Box>
                </Box>
            </Row>
            <Box mr={'s10'}>
                <RadioItem selected={isSelected} />
            </Box>
        </Pressable>
    );
};
